module.exports = __webpack_public_path__ + "media/warranty/proof-of-doc-success-4bb4c3e4.png";